export default ({ onOk, okText, cancelText, title }) => {
  if (window.confirm(title)) {
    onOk();
  }
};
